export default (model) => {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({ ecommerce: null });

  dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: model.transactionReference,
      value: Number(model.totalAmount),
      currency: model.currencyCode,
      items: [
        {
          item_id: model.productId,
          item_name: model.productName,
          currency: model.currencyCode,
          index: 0,
          item_variant: model.productVariant,
          price: Number(model.productPrice),
          quantity: Number(model.productQuantity),
        },
      ],
    },
  });
};
